var exports = {
  "KO": "dialogHeader__j0e21E",
  "iU": "message__2QEUra",
  "g1": "record__PUtA9L",
  "eN": "actor___xZni9",
};

module.exports = exports;
